// src/js/components/Evaluation/Results.js
import React, { Component } from "react";
import { connect } from "react-redux";

import './ActionPlanModule.css';
import ActionPlanSubmodule from "./ActionPlanSubmodule";

const mapStateToProps = state => {
    return {
        actionplan: state.data.actionplan.modules
    };
};

function mapDispatchToProps(dispatch) {
    return {};
}

class ConnectedActionPlanModule extends Component {
    constructor(props) {
        super(props);
        this.DisplayAPSubmodule = this.DisplaySubmodule.bind(this);
    }

    DisplaySubmodule(submodule, index) {
        return (
            <ActionPlanSubmodule key={index} submodule={submodule} submoduleindex={index} moduleindex={this.props.index} />
        )
    }

    render() {
        // console.log(this.props.benchmark);
        // console.log(this.props.module);
        // console.log(this.props.index);

        return(
            <div className="evResultModule">
                <h3>{this.props.actionplan[this.props.index].heading}</h3>
                <div>
                    <table className={'aptable'} cellPadding={0} cellSpacing={0}>
                        <tbody>
                            <tr>
                                <th>Title</th>
                                <th>Action</th>
                                <th>Due Date</th>
                                <th>Responsible</th>
                                <th>Resources</th>
                                <th>Status</th>
                                <th>Comments</th>
                            </tr>
                            {this.props.module.map((submodule, index) => this.DisplayAPSubmodule(submodule,index) ) }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}
const ActionPlanModule = connect(mapStateToProps,mapDispatchToProps)(ConnectedActionPlanModule);

export default ActionPlanModule;